module.exports = __webpack_public_path__ + "static/appartment-eb4fe4ab474a170b6a570c6abff3d49d.png";